import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import DashboardSmartviewNavigation from 'widgets/dashboard/smartviews/DashboardSmartviewNavigation'
import { Translation, Translator } from '@morningtrain/react-translations'
import {
  Collection,
  ForEachModel,
  WhenCollectionIsEmpty,
  WhenCollectionIsNotEmpty,
  WhenLoaded
} from '@morningtrain/react-resources'
import { Can } from '@morningtrain/react-auth'
import Widget from '../../Widget'
import SmartviewHeader from '../../smartviews/partials/SmartviewHeader'
import * as UI from 'ui'
import { SelectedDepartmentFilter } from '../../../support/filters'
import ChecklistSmartviewSection from '../partials/ChecklistSmartviewSection'

export default function ChecklistsTodayDashboardSmartview () {
  return (
    <Smartview size='xs'>
      <DashboardSmartviewNavigation active='checklists' />
      <Can permission='api.dashboard.forecast_summary'>
        <Widget>
          <Translator namespace='dashboard.checklists'>
            <SmartviewHeader>
              <UI.SecondaryHeading>
                <Translation name='title' />
              </UI.SecondaryHeading>
            </SmartviewHeader>
            <Collection resourceName='checklists.checklists' operationName='dashboard'>
              <SelectedDepartmentFilter />
              <WhenLoaded>
                <WhenCollectionIsNotEmpty>
                  <ForEachModel>
                    <div className='mb-10'>
                      <ChecklistSmartviewSection />
                    </div>
                  </ForEachModel>
                </WhenCollectionIsNotEmpty>
                <WhenCollectionIsEmpty>
                  <Translation name='no_checklists' />
                </WhenCollectionIsEmpty>
              </WhenLoaded>

            </Collection>
          </Translator>
        </Widget>
      </Can>
    </Smartview>
  )
}
